import { CircularProgress, IconButton } from "@material-ui/core";
import { CloseOutlined, DragIndicator } from "@material-ui/icons";
import { Resizable } from "re-resizable";
import { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import Draggable from "react-draggable";

const DialogDragable = ({
  open,
  onClose,
  title,
  isLoading,
  children,
  defaultScrollToBottom,
  defaultWidth = "50vw",
  enable,
  containerStyle,
}) => {
  const [firstRender, setFirstRender] = useState(true);

  const [resized, setResized] = useState(false);

  useEffect(() => {
    if (resized) setFirstRender(false);
  }, [resized]);

  return (
    <>
      {open &&
        ReactDOM.createPortal(
          <Draggable handle="strong">
            <div
              style={{
                position: "fixed",
                zIndex: 9999,
                color: "black",
                boxShadow: "1px 1px 4px 2px lightgrey",
                backgroundColor: "#fff",
                fontWeight: 400,
                top: "5vh",
                left: "5vw",
              }}>
              <Resizable
                minWidth={360}
                minHeight={360}
                maxHeight="90vh"
                maxWidth="90vw"
                defaultSize={{ width: defaultWidth }}
                onResize={() => setResized(true)}
                style={{ display: "flex", flexDirection: "column" }}
                enable={enable}>
                <div
                  style={{
                    display: "flex",
                    paddingTop: 10,
                    paddingLeft: 15,
                    paddingRight: 5,
                  }}>
                  <div
                    style={{
                      display: "flex",
                      flex: 1,
                      fontSize: 18,
                      fontWeight: 600,
                      alignItems: "center",
                    }}>
                    {title}
                  </div>
                  <strong>
                    <IconButton
                      style={{ cursor: "move", width: 48, height: 48 }}>
                      <DragIndicator />
                    </IconButton>
                  </strong>

                  <IconButton
                    onClick={onClose}
                    style={{ width: 48, height: 48 }}>
                    <CloseOutlined />
                  </IconButton>
                </div>

                {!isLoading && (
                  <div
                    style={{
                      paddingLeft: 15,
                      paddingRight: 15,
                      maxHeight: firstRender
                        ? "calc(90vh - 58px)"
                        : "calc(100% - 58px)",
                      overflow: "auto",
                      flex: 1,
                      ...(defaultScrollToBottom && {
                        display: "flex",
                        flexDirection: "column-reverse",
                      }),
                      ...containerStyle,
                    }}>
                    {children}
                  </div>
                )}
                {isLoading && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: 300,
                    }}>
                    <CircularProgress />
                  </div>
                )}
              </Resizable>
            </div>
          </Draggable>,
          document.body
        )}
    </>
  );
};

export default DialogDragable;
